// extracted by mini-css-extract-plugin
module.exports = {"toolbox":"toolbox--1NI9t","settings":"settings--2-H6-","validationErrors":"validationErrors--ubXwK","templatetitle":"templatetitle--o7bTB","content":"content--2sBbX"};